export default "__VITE_ASSET__CcnKjFX8__"